import activityFactory from '@polleverywhere/core/lib/activity_factory.js'
import { singularize } from '@polleverywhere/core/lib/util.js'
import ActivityFlow from '@polleverywhere/core/lib/models/activity_flow'

function urlToModel (url) {
  if (url.path() === '/join_instructions') {
    return 'join_instructions'
  }

  const activity = activityFactory({
    type: singularize(url.segment(0)),
    permalink: url.segment(1)
  })

  if (!activity) {
    return null
  }

  const flowName = url.query(true).flow
  if (flowName) {
    return new ActivityFlow({
      type: flowName,
      activity
    })
  }

  return activity
}

export default function (activityUrls = []) {
  return activityUrls.map(urlToModel).filter(Boolean)
}
